import { render, staticRenderFns } from "./vSelectColors.vue?vue&type=template&id=aac9dd68&scoped=true&"
import script from "./vSelectColors.vue?vue&type=script&lang=js&"
export * from "./vSelectColors.vue?vue&type=script&lang=js&"
import style0 from "./vSelectColors.vue?vue&type=style&index=0&id=aac9dd68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac9dd68",
  null
  
)

export default component.exports